import React, { lazy, Suspense } from "react";

export { default as AllSellProperty } from "./SellProperty/AllSellProperty";
export { default as AllRentProperty } from "./RentProperty/AllRentProperty";
export { default as AllSellRequired } from "./RequiredProperty/AllSellRequired";

const LazyReEditSellDetail = lazy(() =>
  import("./SellProperty/ReEditSellDetail")
);
const LazyReEditRentDetail = lazy(() =>
  import("./RentProperty/ReEditRentDetail")
);
const LazyReSellListProperty = lazy(() =>
  import("./SellProperty/ReSellListProperty")
);
const LazyReRentListProperty = lazy(() =>
  import("./RentProperty/ReRentListProperty")
);
export const ReEditSellDetail = () => (
  <Suspense fallback="loading...">
    <LazyReEditSellDetail />
  </Suspense>
);
export const ReEditRentDetail = () => (
  <Suspense fallback="loading...">
    <LazyReEditRentDetail />
  </Suspense>
);
export const ReSellListProperty = () => (
  <Suspense fallback="loading...">
    <LazyReSellListProperty />
  </Suspense>
);
export const ReRentListProperty = () => (
  <Suspense fallback="loading...">
    <LazyReRentListProperty />
  </Suspense>
);
